import ExportCsvIcon from "../../public/images/ExportCsvIcon.png";
import { IconButton, IconButtonProps } from "@mui/material";

type ExportCsvBtnPropsType = IconButtonProps & {
    customwidth?: string;
    customheight?: string;
};

export default function ExportCsvBtn(props: ExportCsvBtnPropsType) {
    return (
        <IconButton {...props}>
            <img
                title="Export csv"
                src={ExportCsvIcon}
                alt="csv"
                width={props?.customwidth ?? "40"}
                height={props?.customheight ?? "40"}
            />
        </IconButton>
    );
}
